export default __webpack_public_path__ + "static/media/liquidity_provider.7e8372e6.png";